var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderTab',{attrs:{"isbg":_vm.isScroll}}),_c('RouterView',{class:_vm.$route.meta.bg ? 'pt80' : ''}),_c('BottomBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }